/**
 * Shared React Query options for "session cache" list/count queries on the
 * main tabs (Dashboard, Case Library, Domain Research, Enterprise Systems,
 * Company Research, Industry Research, Agent Builder).
 *
 * Policy: once a tab's data is fetched, it is served from cache for the whole
 * session. Revisiting the tab (without changing filters) makes NO API call.
 * The data is only re-fetched when:
 *   - a filter that's part of the queryKey changes (new key → new fetch),
 *   - a create/edit/delete mutation calls invalidateQueries on the list key,
 *   - the user clicks the tab's Refresh button (refetch), or
 *   - the page is reloaded.
 *
 * Spread it into a useQuery call:  useQuery({ queryKey, queryFn, ...SESSION_CACHE })
 */
export const SESSION_CACHE = {
  staleTime: Infinity, // never self-stales → no refetch on remount/revisit
  gcTime: Infinity, // keep cached for the whole session (survives tab switches)
  // NOT refetchOnMount: false. That flag also suppressed the refetch after an
  // invalidateQueries() that ran while the list page was unmounted (e.g. the
  // Discovery wizard creating a case, then the user opening Case Library), so
  // the invalidated list was served stale for the rest of the session and the
  // new case was missing until a hard reload. staleTime: Infinity already
  // guarantees "no refetch on revisit"; the default refetchOnMount (refetch
  // only when stale) is exactly the invalidation contract described above.
} as const;
